import script from "./DebugInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugInfo.vue?vue&type=script&setup=true&lang=js"

import "./DebugInfo.vue?vue&type=style&index=0&id=eef8d740&scoped=true&lang=css"

import exportComponent from "../../../author/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eef8d740"]])

export default __exports__